module.exports = __webpack_public_path__ + "static/media/Relevance_ICON.ab18fee8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/drivers/Relevance_ICON.svg
// module id = 1606
// module chunks = 0